export const BRAND = {
  name: "DreamFly Travels",
  tagline: "Luxury International Travel Packages from India",
  subtagline:
    "Maldives • Europe • UK • Thailand • Africa — curated holidays with the best pricing and trusted global DMC partners.",
  whatsappNumber: "917603046932",
  whatsappDisplay: "+91 76030 46932",
  email: "sales@dreamflytravels.co.in",
  phoneDisplay: "+91 76030 46932",
  logoUrl: "/brand/dreamfly-badge-transparent.png",
  logoFullUrl:
    "https://customer-assets.emergentagent.com/job_curated-escapes-4/artifacts/tv3eme7w_DreamFly%20Logo%20Updated.jpeg",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/30037392/pexels-photo-30037392.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  about:
    "https://traveltradejournal.com/wp-content/uploads/2024/11/Rail-Europe-hosts-FAM-trip-4.jpg",
  maldives:
    "https://images.pexels.com/photos/3319961/pexels-photo-3319961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  europe:
    "https://images.unsplash.com/photo-1662653554950-13870f8473fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  uk: "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  thailand:
    "https://images.pexels.com/photos/4023516/pexels-photo-4023516.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  africa:
    "https://customer-assets.emergentagent.com/job_curated-escapes-4/artifacts/y7vw547l_WhatsApp%20Image%202026-05-05%20at%2012.18.43%20PM.jpeg",
  singapore:
    "https://images.pexels.com/photos/31949002/pexels-photo-31949002.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  malaysia:
    "https://images.unsplash.com/photo-1553383398-c40c57291c60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  russia:
    "https://images.unsplash.com/photo-1757249212657-9adc194ec33d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const PACKAGES = [
  {
    id: "maldives",
    country: "Maldives",
    flag: "🌴",
    badge: "Signature",
    duration: "3 Nights · 4 Days",
    price: "₹80,000",
    priceNote: "per person, on twin-sharing",
    image: IMAGES.maldives,
    tagline: "Overwater villas, glass-clear lagoons, quiet luxury.",
    description:
      "Our flagship experience. Handpicked resorts, speedboat & seaplane transfers, candlelit dinners on the sand, and honeymoon touches on request.",
    inclusions: [
      "Return airport transfers (speedboat / seaplane)",
      "Daily breakfast or half-board options",
      "Water villa upgrades on request",
      "Honeymoon package add-ons",
    ],
    resorts: [
      "Centara Ras Fushi",
      "Taj Exotica",
      "Anantara Resorts",
      "Cinnamon Hotels",
      "Cocoon Maldives",
      "Dhigafaru Island",
      "Four Seasons",
      "Ritz-Carlton",
      "St. Regis",
      "SO/ Maldives",
    ],
  },
  {
    id: "europe",
    country: "Europe",
    flag: "🇪🇺",
    badge: "Grand Tour",
    duration: "7 Nights · 8 Days",
    price: "₹1,50,000+",
    priceNote: "per person, group departures",
    image: IMAGES.europe,
    tagline: "Eight countries, one unforgettable rhythm.",
    description:
      "A classic Europe circuit covering iconic cities, alpine views, and canal towns — available as group tours or fully independent (FIT) departures.",
    inclusions: [
      "8 countries · 7 nights",
      "Group tours + FIT customisation",
      "Sightseeing & city passes",
      "Private & shared transfers",
    ],
    resorts: [],
  },
  {
    id: "uk",
    country: "United Kingdom",
    flag: "🇬🇧",
    badge: "City Escape",
    duration: "Flexible itineraries",
    price: "On request",
    priceNote: "FIT & group options",
    image: IMAGES.uk,
    tagline: "London, the Cotswolds and storied countryside.",
    description:
      "London-focused stays with easy extensions to Edinburgh, Manchester and the English countryside. Perfect for families and first-time travellers.",
    inclusions: [
      "London-focused stays",
      "FIT & group tours",
      "Visa assistance",
      "Theatre, dining & day-trip planning",
    ],
    resorts: [],
  },
  {
    id: "thailand",
    country: "Thailand",
    flag: "🇹🇭",
    badge: "Beach & City",
    duration: "4–8 Nights",
    price: "On request",
    priceNote: "budget to luxury tiers",
    image: IMAGES.thailand,
    tagline: "Phuket sunsets, Krabi cliffs, Bangkok buzz.",
    description:
      "From backpacker-friendly escapes to five-star indulgences. Split your stay across islands and the capital for the best of both worlds.",
    inclusions: [
      "Phuket · Krabi · Bangkok",
      "Budget to luxury options",
      "Private transfers & island hopping",
      "Honeymoon & group departures",
    ],
    resorts: [],
  },
  {
    id: "africa",
    country: "Africa",
    flag: "🦁",
    badge: "Wild Luxury",
    duration: "6–10 Nights",
    price: "On request",
    priceNote: "tailored safaris",
    image: IMAGES.africa,
    tagline: "Kenya & Tanzania safaris. Zanzibar honeymoons.",
    description:
      "World-class game drives across the Masai Mara and Serengeti, paired with barefoot beach days on Zanzibar. Our most soul-moving itineraries.",
    inclusions: [
      "Kenya & Tanzania safaris",
      "Zanzibar honeymoon add-on",
      "4×4 safari vehicles & guides",
      "Luxury tented camps",
    ],
    resorts: [],
  },
];

export const SERVICES = [
  {
    icon: "sparkles",
    title: "Customized Holiday Packages",
    body: "Itineraries designed around your pace, taste and budget — never off a shelf.",
  },
  {
    icon: "hotel",
    title: "Hotel Bookings",
    body: "Preferred rates at boutique stays and world-class resorts across the globe.",
  },
  {
    icon: "stamp",
    title: "Visa Assistance",
    body: "Documentation, appointments and guidance — stress-free from start to stamp.",
  },
  {
    icon: "car",
    title: "Transfers & Tours",
    body: "Private cars, skip-the-line passes and expert local guides on the ground.",
  },
  {
    icon: "heart",
    title: "Honeymoon Planning",
    body: "Thoughtful touches, private dinners, and intimate upgrades for the two of you.",
  },
  {
    icon: "users",
    title: "Group Tours & FIT",
    body: "Scheduled group departures or fully independent travel — your call.",
  },
];

export const UPCOMING = [
  { name: "Singapore", image: IMAGES.singapore },
  { name: "Malaysia", image: IMAGES.malaysia },
  { name: "Russia", image: IMAGES.russia },
];

export const WHY_US = [
  {
    title: "Luxury at affordable prices",
    body: "Direct DMC partnerships mean five-star experiences without the five-star markup.",
  },
  {
    title: "Personalized service",
    body: "One dedicated travel curator from first enquiry to your return flight.",
  },
  {
    title: "Trusted global partners",
    body: "Resort groups, airlines and ground teams we've worked with for years.",
  },
  {
    title: "Fast response",
    body: "Most inquiries answered within a few hours — often minutes on WhatsApp.",
  },
  {
    title: "End-to-end solutions",
    body: "Flights, stays, visas, transfers and on-ground support — all in one place.",
  },
];

export const BUDGETS = [
  "Under ₹50,000",
  "₹50,000 – ₹1,00,000",
  "₹1,00,000 – ₹2,50,000",
  "₹2,50,000 – ₹5,00,000",
  "₹5,00,000+",
];

export const DESTINATIONS_LIST = [
  "Maldives",
  "Europe (Multi-country)",
  "United Kingdom",
  "Thailand",
  "Africa (Safari / Zanzibar)",
  "Singapore",
  "Malaysia",
  "Russia",
  "Domestic India",
  "Not sure yet",
];
